import { SearchProduct } from '@winelivery-org/wl-client-sdk-js/dist/models/search';
import { useTranslations } from 'next-intl';
import { Link } from '@/i18n/routing';
import ProductDetailSection from './ProductDetailSection';
import Image from 'next/image';

interface Props {
  product: SearchProduct;
}

function ProductDetailSectionOccasions({ product }: Props) {
  const t = useTranslations('shop');

  if (product.occasions.length === 0) {
    return null;
  }

  return (
    <ProductDetailSection title={t('detail.occasion.title')}>
      <div className="flex flex-wrap gap-2">
        {product.occasions.map((occasion) => (
          <Link
            className="inline-flex items-center py-1 pl-1 pr-2 gap-2 rounded-full bg-greyscale-offwhite border border-greyscale-separator cursor-pointer no-underline"
            href={{ pathname: '/shop', query: { occasion: occasion.slug } }}
            key={occasion.slug}
          >
            <div className="relative flex items-center justify-center h-10 w-10 rounded-full bg-primary/10 overflow-hidden">
              <Image
                fill
                className="object-cover"
                src={occasion.iconUrl || ''}
                alt={occasion.name}
              />
            </div>
            <span className="text-base text-greyscale-body font-medium tracking-tight">
              {occasion.name}
            </span>
          </Link>
        ))}
      </div>
    </ProductDetailSection>
  );
}

export default ProductDetailSectionOccasions;
